import { Navigate, BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import { AuthProvider, useAuth } from '@/lib/auth';
import AppShell from '@/components/AppShell';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import NewEngagementPage from '@/pages/NewEngagementPage';
import EngagementDetailPage from '@/pages/EngagementDetailPage';
import ReportsPage from '@/pages/ReportsPage';
import RemindersPage from '@/pages/RemindersPage';
import SettingsPage from '@/pages/SettingsPage';
import HelpPage from '@/pages/HelpPage';
import PublicReportPage from '@/pages/PublicReportPage';
import AuditTrailPage from '@/pages/AuditTrailPage';
import MatrixPage from '@/pages/MatrixPage';
import { Spinner } from '@/components/Common';

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner label="Loading…" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster
            position="top-center"
            richColors
            toastOptions={{
              style: { fontFamily: 'Inter, sans-serif', borderRadius: 2 },
            }}
          />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/r/:token" element={<PublicReportPage />} />
            <Route path="/" element={<Protected><DashboardPage /></Protected>} />
            <Route path="/new" element={<Protected><NewEngagementPage /></Protected>} />
            <Route path="/engagements/:id" element={<Protected><EngagementDetailPage /></Protected>} />
            <Route path="/reports" element={<Protected><ReportsPage /></Protected>} />
            <Route path="/reminders" element={<Protected><RemindersPage /></Protected>} />
            <Route path="/audit-trail" element={<Protected><AuditTrailPage /></Protected>} />
            <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
            <Route path="/matrix" element={<Protected><MatrixPage /></Protected>} />
            <Route path="/matrix/:stateCode" element={<Protected><MatrixPage /></Protected>} />
            <Route path="/help" element={<Protected><HelpPage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
